const isPresent = (value)=>{
    return value !== null && value !== undefined;
};
const parseNumber = (value)=>{
    if (!isPresent(value)) {
        return null;
    }
    const parsedValue = Number(value);
    if (Number.isNaN(parsedValue)) {
        return null;
    }
    return parsedValue;
};
const strict = (value)=>{
    if (!isPresent(value)) {
        throw Error('Value is not present');
    }
    return value;
};
const isDefined = (value)=>isPresent(value) && Boolean(value);
const isObject = (value)=>typeof value === 'object' && !Array.isArray(value) && value !== null;

export { isDefined, isObject, isPresent, parseNumber, strict };
